<template>
  <div class="content-block">
    <ProjectForm
      @done="onDone"
    ></ProjectForm>
  </div>
</template>

<script>
import ProjectForm from 'CORE/components/project/form'

export default {
    name: 'ProjectNewView',
    components: {
        ProjectForm,
    },
    methods: {
        onDone() {
            this.$router.back()
        },
    },
}
</script>
